import axios from "axios";
import md5 from "md5";

const config =
  typeof window !== "undefined" ? (window.appConfig ?? {}) : {};
const port = config.API_PORT ?? process.env.REACT_APP_API_PORT;
const API_URL =
  (config.PROTOCOL ?? process.env.REACT_APP_PROTOCOL) +
  (config.HOSTNAME ?? process.env.REACT_APP_HOSTNAME) +
  (port ? ":" + port : "") +
  "/";

class AuthService {
  login(email, password, token) {
    let md5Password = md5(password);
    return axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
      url: API_URL + "login",
      data: {
        email: email,
        password: md5Password,
        token: token,
      },
    });
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
